import { CONSTANT } from '@const';
import { DeviceMakeModelItem, DqpDeviceType, MakeModelFilter } from '@types';
import { ReasonForInspectionOption } from '@utils/moduleAForm';

import { ApiParams, ApiService } from '../api/ApiService';

export class MakeModelService extends ApiService {
	protected static baseUrl = CONSTANT.DQP_API_BASE_URL;

	static async getMakesModels(deviceType?: DqpDeviceType): Promise<DeviceMakeModelItem[]> {
		const filter: MakeModelFilter = {
			deviceType: deviceType,
		};
		const params: ApiParams = {
			method: 'GET',
			url: CONSTANT.DQP_MAKES_MODELS_API_URL,
			queryParams: filter,
		};
		return await this.executeApiRequest(params);
	}

	static filterApprovedMakesModels(
		items: DeviceMakeModelItem[],
		deviceType?: DqpDeviceType,
		reasonForInspection?: ReasonForInspectionOption,
	): DeviceMakeModelItem[] {
		const { APPROVED, EXISTING_APPROVED } = DeviceMakeModelItem.patternApproved;
		return items.filter(item => {
			if (reasonForInspection === ReasonForInspectionOption.NewMeter) {
				// SC meters must be approved
				if (deviceType === DqpDeviceType.SC_METER) {
					return item.patternApproved === APPROVED;
				}
				// Modular meters can be approved or existing approved
				else if (deviceType === DqpDeviceType.MODULAR_METER) {
					return item.patternApproved === APPROVED || item.patternApproved === EXISTING_APPROVED;
				}
				// Exclude all other device types for new meter inspections
				return false;
			} else if (reasonForInspection === ReasonForInspectionOption.ExistingMeter) {
				// Include approved and existing approved options
				return item.patternApproved === APPROVED || item.patternApproved === EXISTING_APPROVED;
			}

			// Return all makes and models for other cases
			return true;
		});
	}
}
